import script from "./IncomeStatement.vue?vue&type=script&setup=true&lang=js"
export * from "./IncomeStatement.vue?vue&type=script&setup=true&lang=js"

import "./IncomeStatement.vue?vue&type=style&index=0&id=1780281c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1780281c"]])

export default __exports__